import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  formatPhone(event) {
    let value = event.target.value.replace(/\D/g, "")
    if (value.length > 11) value = value.slice(0, 11)

    if (value.length > 6) {
      value = `(${value.slice(0, 2)}) ${value.slice(2, 7)}-${value.slice(7)}`
    } else if (value.length > 2) {
      value = `(${value.slice(0, 2)}) ${value.slice(2)}`
    } else if (value.length > 0) {
      value = `(${value}`
    }

    event.target.value = value
  }

  selectPlan() {
    // visual feedback is handled via CSS :checked selector on the radio inputs
  }
}
